// extracted by mini-css-extract-plugin
export default {"wrapper":"hover-over_wrapper__NL58p","tipTitle":"hover-over_tipTitle__8+jyH","tip":"hover-over_tip__a1Mgj","_under":"hover-over__under__2oDgW"};